import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';

import Component from "components/component";

import CustomSizeInput from "./custom-size-input";

export default class SizeOption extends Component {
  static propTypes = {
    optionValue: ImmutablePropTypes.map.isRequired,
    isSelected: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
    customValueChanged: PropTypes.func.isRequired,
    selectable: PropTypes.bool.isRequired,
    productType: PropTypes.string.isRequired,
    inSlider: PropTypes.bool
  };

  render() {
    const {
      optionValue,
      isSelected,
      handleClick,
      customValueChanged,
      selectable,
      productType,
      inSlider,
      userRole,
    } = this.props;

    const {
      id,
      displayName,
      customValue,
      optionTypeId,
      customMax
    } = optionValue.toObject();

    const htmlId = inSlider
      ? `option_value_${id}_slider`
      : `option_value_${id}`;
    const thumbnailImage = getThumbnailImageUrl(optionValue);

    let classSet = ["size-option-selection", "selection"];
    let onClick = handleClick.bind(this, id);

    if (isSelected) {
      classSet.push("selection-selected");
    }

    if (!selectable) {
      classSet.push("unselectable");
      onClick = null;
    }

    classSet = classSet.join(" ");

    const selectionImageClassSet = `selection-image ${productType}`;

    if (displayName === "Custom") {
      if (!userRole || userRole === 'retail_user') {
        return null;
      }

      const onCustomChange = value => {
        customValueChanged(optionTypeId, id, value);
      };

      return (
        <div key={id} id={htmlId} onClick={onClick} className={classSet}>
          <CustomSizeInput
            value={customValue}
            onChange={onCustomChange}
            displayName={displayName}
            max={customMax}
          />
        </div>
      );
    }

    return (
      <div onClick={onClick} key={id} className={classSet} id={htmlId}>
        <img src={thumbnailImage} className={selectionImageClassSet} />

        <div className="selection-details">
          <p>{displayName}"</p>
        </div>
      </div>
    );
  }
}

function getThumbnailImageUrl(optionValue) {
  const variant = optionValue.get("variant");
  let thumbnailImage = optionValue.get("thumbnailImage");

  if (!variant) {
    return thumbnailImage;
  }

  const lineDrawings = variant.get("lineDrawings");

  if (lineDrawings.size === 0) {
    return thumbnailImage;
  }

  return lineDrawings.first().get("url");
}
